import React, { useEffect } from "react";
import { Redirect, Route } from "react-router-dom";
import { setAuthorization } from "../helpers/api_helper";
import { useDispatch } from "react-redux";

import { useProfile } from "../Components/Hooks/UserHooks";
import { cheminConnexion } from "../espace";

import { logoutUser } from "../store/actions";

const AuthProtected = ( props ) =>
{
  const dispatch = useDispatch();
  const { userProfile, loading, token } = useProfile();

  useEffect( () =>
  {
    if ( userProfile && !loading && token )
    {
      setAuthorization( token );
    } else if ( !userProfile && loading && !token )
    {
      dispatch( logoutUser() );
    }
  }, [ token, userProfile, loading, dispatch ] );

  /*
    redirect is un-auth access protected routes via url
    */

  if ( !userProfile && loading && !token )
  {
    return (
      // Chaque espace renvoie vers son propre écran de connexion : dans
      // l'espace organisateur, « /login » n'existe pas.
      <Redirect
        to={ { pathname: cheminConnexion, state: { from: props.location } } }
      />
    );
  }

  return <>{ props.children }</>;
};

const AccessRoute = ( { component: Component, ...rest } ) =>
{
  return (
    <Route
      { ...rest }
      render={ props =>
      {
        return ( <> <Component { ...props } /> </> );
      } }
    />
  );
};

export { AuthProtected, AccessRoute };